import { getGlobalConfig } from '../api/pdf/globalConfig'

let config

getGlobalConfig().then(currentConfig => (config = currentConfig))

export { getGlobalConfig, config }
